import {
  Form,
  Button,
  Dropdown,
  Modal,
  Row,
  Col,
  Badge,
} from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  EditIcon,
  FileListIcon,
  FilterTwoIcon,
  TrashIcon,
  ExportIcon,
  AddCircleIcon,
} from "../Icons";
import TableComponent from "../TableComponent";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import EyeIcon from "mdi-react/EyeIcon";
import CachedIcon from "mdi-react/CachedIcon";
import { FaRoute, FaMapMarkerAlt, FaClock, FaRoad } from "react-icons/fa";
import ConfirmDialog from "../ConfirmDialogue";
import { useAuth } from "../../hooks/useAuth";
import queryString from "query-string";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
} from "../../utils/hooks";
import ModalLoader from "../utils/ModalLoader";
import { Formik, Field, FieldArray } from "formik";
import {
  getCoordinateOfAddress,
  getDistanceOfAddresses,
} from "../maintance/distanceMatrix";
import CreatableSelect from "react-select/creatable";
import TrashIcon2 from "mdi-react/TrashIcon";
import PlusIcon from "mdi-react/PlusIcon";
import { Divider } from "antd";
import RouteDetailsModal from "./RouteDetails";
const SAVED_ADDRESSES = [];
export default function FleetRoutes() {
  const { backendUrl } = useAuth();
  const queryClient = useQueryClient();
  const [showFilter, setShowFilter] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isMainLoading, setIsMainLoading] = useState(false);
  const [editRoute, setEditRoute] = useState(null);
  const [resolvedLocations, setResolvedLocations] = useState({
    origin: null,
    destination: null,
  });

  const initialFilterParams = {
    q: "",
    status: "",
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 20,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);

  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  const [newRoute, setNewRoute] = useState({
    name: "",
    description: "",
    originAddress: "",
    formattedOrigin: "",
    originLat: null,
    originLng: null,
    destinationAddress: "",
    formattedDestination: "",
    destinationLat: null,
    destinationLng: null,
    distance: null,
    estimatedDuration: null,
    waypoints: [],
    isActive: true,
  });

  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  // Fetch routes
  const fetchRoutes = async (params) => {
    const response = await fetch(
      `${backendUrl}/api/fleet/routes?${queryString.stringify(params)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message);
    }

    const result = await response.json();
    return result.data;
  };

  const {
    data = { routes: [], count: 0, page: 1, limit: 20 },
    refetch,
    isLoading,
  } = useQuery(["FLEET_ROUTES", queryParams], () => fetchRoutes(queryParams), {
    keepPreviousData: true,
    staleTime: 0,
  });

  // Create route mutation
  const createRouteMutation = useMutation(
    async (routeData) => {
      const response = await fetch(`${backendUrl}/api/fleet/routes`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(routeData),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      return response.json();
    },
    {
      onSuccess: () => {
        toast.success("Route created successfully");
        queryClient.invalidateQueries(["FLEET_ROUTES"]);
        setShowAddModal(false);
        resetNewRoute();
        setResolvedLocations({
          originResolved: null,
          destinationResolved: null,
        });
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  // Update route mutation
  const updateRouteMutation = useMutation(
    async ({ routeId, routeData }) => {
      const response = await fetch(
        `${backendUrl}/api/fleet/routes/${routeId}`,
        {
          method: "PATCH",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(routeData),
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      return response.json();
    },
    {
      onSuccess: () => {
        toast.success("Route updated successfully");
        queryClient.invalidateQueries(["FLEET_ROUTES"]);
        setShowEditModal(false);
        setEditRoute(null);
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  // Delete route mutation
  const deleteRouteMutation = useMutation(
    async (routeId) => {
      const response = await fetch(
        `${backendUrl}/api/fleet/routes/${routeId}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message);
      }

      return response.json();
    },
    {
      onSuccess: () => {
        toast.success("Route deleted successfully");
        queryClient.invalidateQueries(["FLEET_ROUTES"]);
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterParams({
      ...filterParams,
      [name]: value,
    });
  };

  const resetFilters = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSearch = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const handleViewDetails = (route) => {
    setSelectedRoute(route);
    setShowDetailsModal(true);
  };

  const handleEdit = (route) => {
    setEditRoute(route);
    setShowEditModal(true);
  };

  const handleDelete = async (route) => {
    const confirmed = await ConfirmDialog({
      title: "Delete Route",
      description: `Are you sure you want to delete <b>${route.name}</b>?`,
    });

    if (confirmed) {
      deleteRouteMutation.mutate(route.route_id);
    }
  };

  const resetNewRoute = () => {
    setNewRoute({
      name: "",
      description: "",
      originAddress: "",
      originLat: null,
      originLng: null,
      destinationAddress: "",
      destinationLat: null,
      destinationLng: null,
      distance: null,
      estimatedDuration: null,
      waypoints: [],
      isActive: true,
    });
  };

  const handleCreateRoute = async (values) => {
    try {
      const routeData = {
        ...values,
        destinationAddress: values.destinationAddress?.label,
        originAddress: values.originAddress?.label,
      };

      // Ensure coordinates are set
      if (resolvedLocations.origin) {
        routeData.originLat = resolvedLocations.origin.lat;
        routeData.originLng = resolvedLocations.origin.lng;
        routeData.originAddress = resolvedLocations.origin.address;
      }

      if (resolvedLocations.destination) {
        routeData.destinationLat = resolvedLocations.destination.lat;
        routeData.destinationLng = resolvedLocations.destination.lng;
        routeData.destinationAddress = resolvedLocations.destination.address;
      }

      // Fetch distance and duration
      if (routeData.originAddress && routeData.destinationAddress) {
        const distData = await getDistanceOfAddresses(
          routeData.originAddress,
          routeData.destinationAddress
        );
        routeData.distance = distData.distance.value;
        routeData.estimatedDuration = Number((distData.duration.value / 60).toFixed(2));
      }

      // Format waypoints
      routeData.waypoints = values.waypoints.filter(
        (wp) => wp.address && wp.lat && wp.lng
      );

      createRouteMutation.mutate(routeData);
    } catch (error) {
      toast.error("Error creating route: " + error.message);
    }
  };

  const handleUpdateRoute = async (values) => {
    try {
      const routeData = { ...values };

      // Ensure coordinates are set
      if (resolvedLocations.origin) {
        routeData.originLat = resolvedLocations.origin.lat;
        routeData.originLng = resolvedLocations.origin.lng;
        routeData.originAddress = resolvedLocations.origin.address;
      }

      if (resolvedLocations.destination) {
        routeData.destinationLat = resolvedLocations.destination.lat;
        routeData.destinationLng = resolvedLocations.destination.lng;
        routeData.destinationAddress = resolvedLocations.destination.address;
      }

      // Fetch distance and duration
      if (routeData.originAddress && routeData.destinationAddress) {
        const distData = await getDistanceOfAddresses(
          routeData.originAddress,
          routeData.destinationAddress
        );
        routeData.distance = distData.distance.value;
        routeData.estimatedDuration = distData.duration.value;
      }

      // Format waypoints
      routeData.waypoints = values.waypoints.filter(
        (wp) => wp.address && wp.lat && wp.lng
      );

      updateRouteMutation.mutate({
        routeId: editRoute.route_id,
        routeData,
      });
    } catch (error) {
      toast.error("Error updating route: " + error.message);
    }
  };

  const getStatusClass = (isActive) => {
    return isActive ? "view_status_all" : "view_status_pending";
  };

  const tableHead = () => (
    <thead>
      <tr>
        <th />
        <th>Name</th>
        <th>Origin</th>
        <th>Destination</th>
        <th>Distance</th>
        <th>Duration</th>
        <th>Status</th>
      </tr>
    </thead>
  );

  const displayTableData = (route) => (
    <>
      <td>
        <Dropdown>
          <Dropdown.Toggle
            variant=""
            className="bg-white border-0"
            bsPrefix="print more"
            style={{ height: "3px" }}
          >
            <DotsHorizontalIcon size={18} />
          </Dropdown.Toggle>
          <Dropdown.Menu
            popperConfig={{ strategy: "fixed" }}
            renderOnMount
            className="dropdown-with-icons"
          >
            <Dropdown.Item onClick={() => handleViewDetails(route)}>
              <EyeIcon size={16} className="me-2" />
              View Details
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleEdit(route)}>
              <EditIcon size={16} className="me-2" />
              Edit Route
            </Dropdown.Item>
            {/* <Dropdown.Item>
              <FileListIcon color={"black"} size={16} className="me-2" />
              Documents
            </Dropdown.Item> */}
            <Dropdown.Divider />
            <Dropdown.Item
              className="text-danger"
              onClick={() => handleDelete(route)}
            >
              <TrashIcon size={16} className="me-2" />
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
      <td className="fw-semibold">{route.name}</td>
      <td>
        <FaMapMarkerAlt className="me-1 text-success" />
        {route.originAddress}
      </td>
      <td>
        <FaMapMarkerAlt className="me-1 text-danger" />
        {route.destinationAddress}
      </td>
      <td>{route.distance ? `${route.distance} miles` : "N/A"}</td>
      <td>
        <FaClock className="me-1" />
        {route.estimatedDuration
          ? `${route.estimatedDuration} mins`
          : "N/A"}
      </td>
      <td>
        <div className={`px-2 ${getStatusClass(route.isActive)}`}>
          {route.isActive ? "ACTIVE" : "INACTIVE"}
        </div>
      </td>
    </>
  );

  return (
    <section className="invoice-wrapped">
      <main className="cash-book">
        <div className="content">
          <div className="content-main">
            {/* Filter Sidebar */}
            <div className={`filter-area ${showFilter ? "open" : "close"}`}>
              <div className="filter-header">
                <h2>
                  <FilterTwoIcon size={20} />
                  Filters
                </h2>
                <Button
                  variant="white"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  ×
                </Button>
              </div>
              <div className="filter-body">
                <Form onSubmit={(e) => e.preventDefault()}>
                  <div className="body">
                    <Form.Group className="mb-2-5">
                      <Form.Label>Search</Form.Label>
                      <Form.Control
                        name="q"
                        placeholder="Route Name, Origin, Destination"
                        value={filterParams.q}
                        onChange={handleFilterChange}
                      />
                    </Form.Group>

                    <Form.Group className="mb-2-5">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={filterParams.status}
                        onChange={handleFilterChange}
                      >
                        <option value="">All Statuses</option>
                        {statusOptions.map((opt) => (
                          <option key={opt.value} value={opt.label}>
                            {opt.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className="buttons rounded">
                    <Button onClick={resetFilters} variant="white">
                      Reset
                    </Button>
                    <Button onClick={handleSearch} variant="primary">
                      Search
                    </Button>
                  </div>
                </Form>
              </div>
            </div>

            {/* Main Content */}
            <div className="content-body">
              <header className="text-nowrap">
                <h1>
                  {!showFilter && (
                    <button
                      onClick={() => setShowFilter(!showFilter)}
                      className="btn filter"
                    >
                      <FilterTwoIcon size={20} />
                    </button>
                  )}
                  Fleet Routes
                  <button
                    title="Refresh"
                    onClick={() => refetch()}
                    className="btn text-primary mx-3"
                  >
                    <CachedIcon />
                  </button>
                </h1>
                <div className="actions d-flex align-items-baseline gap-2">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => {
                      setResolvedLocations({
                        originResolved: null,
                        destinationResolved: null,
                      });
                      setShowAddModal(true);
                    }}
                  >
                    <AddCircleIcon className="me-1" />
                    Add Route
                  </Button>
                  <div className="btn bg print">
                    Export
                    <ExportIcon className="ms-2" />
                  </div>
                </div>
              </header>

              <div className="px-md-4">
                <TableComponent
                  responsive
                  borderless
                  striped
                  className="product-table text-nowrap"
                  tableHeadsFunction={tableHead}
                  tableDataRowFunction={displayTableData}
                  mainDataArray={data.routes}
                />
              </div>

              {data.routes.length === 0 && (
                <div className="d-flex justify-content-center">
                  <div className="info text-center">
                    <h2 className="my-2">No Routes Available</h2>
                  </div>
                </div>
              )}

              {/* Pagination */}
              <div className="d-flex justify-content-between px-3 align-items-center pagination">
                <div className="pagination_left">
                  <p className="m-0 p-0">Show</p>
                  <select
                    value={queryParams.limit}
                    name="limit"
                    className="form-select"
                    onChange={(e) =>
                      setQueryParams({
                        ...queryParams,
                        limit: e.target.value,
                        page: 1,
                      })
                    }
                  >
                    <option value="10">10 rows</option>
                    <option value="20">20 rows</option>
                    <option value="30">30 rows</option>
                    <option value="40">40 rows</option>
                    <option value="50">50 rows</option>
                    <option value="100">100 rows</option>
                  </select>
                </div>
                <p className="m-0">
                  Page {data.page} of {Math.ceil(data.count / data.limit)} (
                  {data.count} total)
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Add Route Modal */}
        <AddEditRouteModal
          isEdit={false}
          initialValues={newRoute}
          onSubmit={handleCreateRoute}
          isLoading={createRouteMutation.isLoading}
          show={showAddModal}
          onHide={() => {
            setShowAddModal(false);
            resetNewRoute();
            setResolvedLocations({
              originResolved: null,
              destinationResolved: null,
            });
          }}
        />

        {/* Edit Route Modal */}
        {editRoute && (
          <AddEditRouteModal
            isEdit={true}
            initialValues={{
              name: editRoute.name || "",
              description: editRoute.description || "",
              originAddress: editRoute.originAddress || "",
              originLat: editRoute.originLat || null,
              originLng: editRoute.originLng || null,
              destinationAddress: editRoute.destinationAddress || "",
              destinationLat: editRoute.destinationLat || null,
              destinationLng: editRoute.destinationLng || null,
              distance: editRoute.distance || null,
              estimatedDuration: editRoute.estimatedDuration || null,
              waypoints: Array.isArray(editRoute.waypoints)
                ? editRoute.waypoints
                : editRoute.waypoints
                ? JSON.parse(editRoute.waypoints)
                : [],
              isActive: editRoute.isActive || false,
            }}
            onSubmit={handleUpdateRoute}
            isLoading={updateRouteMutation.isLoading}
            show={showEditModal}
            onHide={() => {
              setShowEditModal(false);
              setEditRoute(null);
              setResolvedLocations({
                originResolved: null,
                destinationResolved: null,
              });
            }}
          />
        )}

        {/* Route Details Modal */}
        <RouteDetailsModal
          show={showDetailsModal}
          onHide={() => {
            setShowDetailsModal(false);
            setSelectedRoute(null);
          }}
          initRoute={selectedRoute}
        />
      </main>
      <ModalLoader show={isLoading || isMainLoading} />
    </section>
  );
}

const AddEditRouteModal = ({
  isEdit,
  initialValues,
  onSubmit,
  isLoading,
  show,
  onHide,
}) => {
  const [savedAddresses, setSavedAddresses] = useLocalStorage(
    "maintenanceAddresses",
    SAVED_ADDRESSES
  );
  const [calculatingDistance, setCalculatingDistance] = useState(false);

  const handleCreateAddress = (inputValue) => {
    const newAddress = {
      label: inputValue,
      value: inputValue.toLowerCase().replace(/\s+/g, "_"),
    };
    setSavedAddresses([...savedAddresses, newAddress]);
    return newAddress;
  };

  const handleResolveLocation = async (
    address,
    locationType,
    setFieldValue
  ) => {
    try {
      console.log("fetching address details", address);
      if (!address) return;

      const coord = await getCoordinateOfAddress(address);
      console.log("coord gotten: ", coord);
      const resolved = {
        address: coord.formattedAddress || address,
        lat: coord.coordinates.latitude,
        lng: coord.coordinates.longitude,
      };

      console.log({ resolved, locationType });
      if (locationType === "origin") {
        setFieldValue("formattedOrigin", resolved.address);
        setFieldValue("originLat", resolved.lat);
        setFieldValue("originLng", resolved.lng);
      } else {
        setFieldValue("formattedDestination", resolved.address);
        setFieldValue("destinationLat", resolved.lat);
        setFieldValue("destinationLng", resolved.lng);
      }
    } catch (error) {
      toast.error(
        `Failed to resolve ${locationType} address: ${error.message}`
      );
    }
  };

  const handleCalculateDistanceAndTime = async (
    originAddress,
    destinationAddress,
    setFieldValue
  ) => {
    if (!originAddress || !destinationAddress) return;

    setCalculatingDistance(true);
    try {
      const distData = await getDistanceOfAddresses(
        originAddress.label,
        destinationAddress.label
      );

      console.log("distance and time resolved: ", distData);

      // Convert meters to kilometers
      const distanceMiles = Number(distData.distance.value / 1.609).toFixed(2); // converting to miles
      // Convert seconds to minutes
      const durationMinutes = Math.round(distData.duration.value / 60);

      setFieldValue("distance", distanceMiles);
      setFieldValue("estimatedDuration", durationMinutes);
    } catch (error) {
      toast.error(
        `Failed to calculate distance: ${error.message}`
      );
    } finally {
      setCalculatingDistance(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "Edit Route" : "Add New Route"}</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize={isEdit}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          errors,
        }) => {
          console.log({initialData: values})
          return (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="name"
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Field as={Form.Control} type="text" name="description" />
                    </Form.Group>
                  </Col>

                  <Divider />
                  
                  {/* Origin Address */}
                  <Col md={12}>
                    <Form.Group className="mb-3 pb-2">
                      <Form.Label className="mb-1">
                        Origin Address <span className="text-danger">*</span>
                      </Form.Label>
                      <CreatableSelect
                        classNamePrefix="form-select"
                        isSearchable={true}
                        isClearable={true}
                        options={savedAddresses}
                        value={values.originAddress}
                        onChange={(value) => {
                          if (value) {
                            handleResolveLocation(
                              value.label,
                              "origin",
                              setFieldValue
                            );
                            // Trigger distance calculation if destination exists
                            if (values.destinationAddress) {
                              handleCalculateDistanceAndTime(
                                value,
                                values.destinationAddress,
                                setFieldValue
                              );
                            }
                          }
                          setFieldValue("originAddress", value);
                        }}
                        onCreateOption={(inputValue) => {
                          const newAddress = handleCreateAddress(
                            inputValue,
                            "originAddress"
                          );
                          if (inputValue)
                            handleResolveLocation(
                              inputValue,
                              "origin",
                              setFieldValue
                            );
                          setFieldValue("originAddress", newAddress);
                          // Trigger distance calculation if destination exists
                          if (values.destinationAddress) {
                            handleCalculateDistanceAndTime(
                              newAddress,
                              values.destinationAddress,
                              setFieldValue
                            );
                          }
                        }}
                        placeholder="Select or enter origin location..."
                        formatCreateLabel={(inputValue) =>
                          `Add "${inputValue}"`
                        }
                      />
                      {touched.originAddress && errors.originAddress ? (
                        <span className="custom-invalid-feedback">
                          {errors.originAddress}
                        </span>
                      ) : null}
                    </Form.Group>
                  </Col>

                  {/* Origin Resolved Details */}
                  <div className="mt-2 mb-3">
                    <Row>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Label className="small">Latitude</Form.Label>
                          <Form.Control
                            type="number"
                            size="sm"
                            value={values.originLat || ""}
                            onChange={(e) =>
                              setFieldValue("originLat", e.target.value)
                            }
                            step="0.0001"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Label className="small">Longitude</Form.Label>
                          <Form.Control
                            type="number"
                            size="sm"
                            value={values.originLng || ""}
                            onChange={(e) =>
                              setFieldValue("originLng", e.target.value)
                            }
                            step="0.0001"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <small className="mb-3 d-block">
                    <strong>Resolved Address:</strong> {values.formattedOrigin}
                  </small>

                  {/* Destination Address */}
                  <Col md={12}>
                    <Divider />
                    <Form.Group className="mb-3 pb-2">
                      <Form.Label className="mb-1">
                        Destination Address <span className="text-danger">*</span>
                      </Form.Label>
                      <CreatableSelect
                        classNamePrefix="form-select"
                        isSearchable={true}
                        isClearable={true}
                        options={savedAddresses}
                        value={values.destinationAddress}
                        onChange={(value) => {
                          setFieldValue("destinationAddress", value);
                          if (value) {
                            handleResolveLocation(
                              value.label,
                              "destination",
                              setFieldValue
                            );
                            // Trigger distance calculation if origin exists
                            if (values.originAddress) {
                              handleCalculateDistanceAndTime(
                                values.originAddress,
                                value,
                                setFieldValue
                              );
                            }
                          }
                        }}
                        onCreateOption={(inputValue) => {
                          if (inputValue)
                            handleResolveLocation(
                              inputValue,
                              "destination",
                              setFieldValue
                            );
                          const newAddress = handleCreateAddress(inputValue);
                          setFieldValue("destinationAddress", newAddress);
                          // Trigger distance calculation if origin exists
                          if (values.originAddress) {
                            handleCalculateDistanceAndTime(
                              values.originAddress,
                              newAddress,
                              setFieldValue
                            );
                          }
                        }}
                        placeholder="Select or enter destination address..."
                        formatCreateLabel={(inputValue) =>
                          `Add "${inputValue}"`
                        }
                      />
                      {touched.destinationAddress &&
                      errors.destinationAddress ? (
                        <span className="custom-invalid-feedback">
                          {errors.destinationAddress}
                        </span>
                      ) : null}
                    </Form.Group>
                  </Col>

                  {/* Destination Resolved Details */}
                  <div className="mt-2 mb-3">
                    <Row>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Label className="small">Latitude</Form.Label>
                          <Form.Control
                            type="number"
                            size="sm"
                            name="destinationLat"
                            value={values.destinationLat || ""}
                            onChange={(e) =>
                              setFieldValue("destinationLat", e.target.value)
                            }
                            step="0.000001"
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Label className="small">Longitude</Form.Label>
                          <Form.Control
                            type="number"
                            size="sm"
                            name="destinationLng"
                            value={values.destinationLng || ""}
                            onChange={(e) =>
                              setFieldValue("destinationLng", e.target.value)
                            }
                            step="0.000001"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <small className="mb-3 d-block">
                    <strong>Resolved Address:</strong>{" "}
                    {values.formattedDestination}
                  </small>

                  {/* Distance and Duration */}
                  <Col md={12}>
                    <Divider />
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Distance (miles) <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="input-group">
                        <Form.Control
                          type="number"
                          name="distance"
                          value={values.distance || ""}
                          onChange={handleChange}
                          step="0.01"
                          min="0"
                          placeholder="0.0"
                          required
                        />
                        {calculatingDistance && (
                          <span className="input-group-text">
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Calculating...
                          </span>
                        )}
                      </div>
                      {touched.distance && errors.distance ? (
                        <Form.Text className="text-danger">
                          {errors.distance}
                        </Form.Text>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Estimated Duration (minutes) <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="estimatedDuration"
                        value={values.estimatedDuration || ""}
                        onChange={handleChange}
                        step="1"
                        min="0"
                        placeholder="0"
                        required
                      />
                      {touched.estimatedDuration && errors.estimatedDuration ? (
                        <Form.Text className="text-danger">
                          {errors.estimatedDuration}
                        </Form.Text>
                      ) : null}
                    </Form.Group>
                  </Col>

                  {/* Waypoints */}
                  <Col md={12}>
                    <Divider />
                    <Form.Group className="mb-3">
                      <Form.Label>Waypoints</Form.Label>
                      <FieldArray name="waypoints">
                        {(arrayHelpers) => (
                          <div>
                            {values.waypoints.map((waypoint, index) => (
                              <div
                                key={index}
                                className="p-3 mb-2 border rounded"
                              >
                                <Row className="mb-2">
                                  <Col md={12}>
                                    <Form.Group>
                                      <Form.Label className="small">
                                        Stop {index + 1} Address
                                      </Form.Label>
                                      <Field
                                        as={Form.Control}
                                        type="text"
                                        name={`waypoints.${index}.address`}
                                        placeholder="Enter stop address"
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xs={5}>
                                    <Form.Group>
                                      <Form.Label className="small">
                                        Latitude
                                      </Form.Label>
                                      <Field
                                        as={Form.Control}
                                        type="number"
                                        name={`waypoints.${index}.lat`}
                                        placeholder="0.0000"
                                        step="0.000001"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col xs={5}>
                                    <Form.Group>
                                      <Form.Label className="small">
                                        Longitude
                                      </Form.Label>
                                      <Field
                                        as={Form.Control}
                                        type="number"
                                        name={`waypoints.${index}.lng`}
                                        placeholder="0.0000"
                                        step="0.000001"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col
                                    xs={2}
                                    className="d-flex align-items-end"
                                  >
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="w-100"
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <TrashIcon2 color="red" size={16} />
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() =>
                                arrayHelpers.push({
                                  address: "",
                                  lat: null,
                                  lng: null,
                                })
                              }
                            >
                              <PlusIcon size={16} className="me-1" />
                              Add Waypoint
                            </Button>
                          </div>
                        )}
                      </FieldArray>
                    </Form.Group>
                  </Col>

                  {/* Active Status */}
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Active</Form.Label>
                      <Field as={Form.Check} type="checkbox" name="isActive" />
                    </Form.Group>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting || isLoading}
                >
                  {isSubmitting || isLoading
                    ? isEdit
                      ? "Updating..."
                      : "Creating..."
                    : isEdit
                    ? "Update Route"
                    : "Create Route"}
                </Button>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};
